import React, { forwardRef } from "react";

const AnNewDropdown = forwardRef((props, ref) => {
  const {
    containerClass = "",
    style,
    innerContainerStyle,
    toggleDropDown,
    fixedElementStyle,
    displayOnHover,
    children,
  } = props;

  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1,
          ...fixedElementStyle,
        }}
        onClick={(e) => {
          e.stopPropagation();
          toggleDropDown();
        }}
      />

      <div
        ref={ref} 
        className={containerClass}
        style={style}
        onMouseLeave={displayOnHover ? toggleDropDown : null}
      >
        <div
          style={{
            position: "relative",
            zIndex: 99,
            ...innerContainerStyle,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
});

export default AnNewDropdown;
